import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';
import { TableModule }  from '../../table/table.module';

import { JobRowExpandComponent } from './transaction-center.job.row.expand.component';
import { JobStatusBookingPipe }  from './transaction-center.jobs.status-booking.pipe';
import { JobStatusPipe }         from './transaction-center.jobs.status.pipe';
import { PrintJobsComponent }    from './transaction-center.jobs.print.component';
import { SendBulkSmsComponent } from './transaction-center.jobs.send-bulk-sms.component';
import { TransactionCenterJobsComponent } from './transaction-center.jobs.component';

@NgModule({
  declarations: [
    JobRowExpandComponent,
    JobStatusBookingPipe,
    JobStatusPipe,
    PrintJobsComponent,
    SendBulkSmsComponent,
    TransactionCenterJobsComponent
  ],
  entryComponents: [
    JobRowExpandComponent,
    PrintJobsComponent,
    SendBulkSmsComponent,
    TransactionCenterJobsComponent
  ],
  exports: [
    JobRowExpandComponent,
    JobStatusBookingPipe,
    JobStatusPipe,
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    JobStatusBookingPipe,
    JobStatusPipe,
    { provide: 'jobStatusBooking', useClass: JobStatusBookingPipe },
    { provide: 'jobStatus', useClass: JobStatusPipe }
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class TransactionCenterJobsModule {}
